// Action links let a plain URL open part of the workflow page, e.g.
//   /workflow/<projectId>/<workflowId>?action=aiAssistant
//   /workflow/<projectId>/<workflowId>?action=workflowSettings&tab=CARDS
// In help text a relative href ("?action=aiAssistant") targets the current workflow.

const WORKFLOW_SETTINGS_TABS = ['AI', 'CARDS', 'TYPES', 'TAGS', 'GENERAL']

const LINK_ACTION_PARAMS = ['action', 'tab']

const actions = {
  aiAssistant (store) {
    store.commit('setSidePanelTab', 'chatLog')
    store.commit('showSidePanel', true)
  },
  workflowSettings (store, { tab }) {
    const settingsTab = WORKFLOW_SETTINGS_TABS.includes(tab) ? tab : null
    store.dispatch('workflow/openWorkflowSettings', { tab: settingsTab })
  }
}

const getAction = (name) => (Object.hasOwn(actions, name) ? actions[name] : null)

export function runLinkAction (store, query = {}) {
  const action = getAction(query.action)
  // the toolbar hides both targets in view-only mode
  if (!action || store.state.workflow?.isViewOnlyEnabled) {
    return false
  }
  action(store, query)
  return true
}

export function withoutLinkAction (query = {}) {
  const rest = { ...query }
  for (const param of LINK_ACTION_PARAMS) {
    delete rest[param]
  }
  return rest
}

// Runs same-page action links without a reload; returns true when it handled the click
export function handleLinkActionClick (event, router) {
  const link = event.target?.closest?.('a[href]')
  if (!link || link.target === '_blank' || event.defaultPrevented || event.button > 0 ||
    event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
    return false
  }
  const url = new URL(link.href, window.location.href)
  const current = router.currentRoute.value
  // other pages load natively: Workflow.vue doesn't reload on a route-only workflow change
  if (url.origin !== window.location.origin || url.pathname !== current.path ||
    !getAction(url.searchParams.get('action'))) {
    return false
  }
  event.preventDefault()
  router.push({ path: url.pathname, query: { ...current.query, ...Object.fromEntries(url.searchParams) } })
  return true
}
